
// SVG Icon: interact
export default { id: "terriajs-interact" };
export const id = "terriajs-interact";
export const name = "interact";
